import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Stack,
    Typography,
} from '@mui/material';
import { useMemo } from 'react';
import { LabeledValue } from '~/components/Fields/LabeledValue';
import {
    AVAILABLE_ROI_TYPES,
    RoiInterpretedType,
} from '~/domain/dicom/dicomstructureset';
import { ROIState } from '~/state/atoms/structureSet/roiAtoms';

export default function StructureInformation({
    roi,
    onInterpretedTypeChange,
    isEditable,
    getRoiVolumeCm3,
    getRoiEquivalentSphereDiameter,
}: {
    roi: ROIState;
    onInterpretedTypeChange: (value: RoiInterpretedType) => void;
    onDescriptionChange: (value: string) => void;
    isEditable: boolean;
    getRoiVolumeCm3: () => number;
    getRoiEquivalentSphereDiameter: () => number;
}) {
    const allowedTypes = useMemo(() => {
        return Object.entries(AVAILABLE_ROI_TYPES).map(([key, value]) => (
            <MenuItem key={key} value={value}>
                {value}
            </MenuItem>
        ));
    }, []);

    return (
        <Box>
            <Stack spacing={1} mb={2}>
                <LabeledValue
                    label="Approval status"
                    value={roi.approvalStatus}
                />
                <LabeledValue
                    label="Structure Volume (cm&sup3;)"
                    value={getRoiVolumeCm3().toFixed(2)}
                />
                <LabeledValue
                    label="Eq. Sphere Diameter (cm)"
                    value={getRoiEquivalentSphereDiameter().toFixed(2)}
                />
                <LabeledValue
                    label="Contour origin"
                    value={roi.roiGenerationAlgorithm}
                />

                <Typography variant="subtitle2" fontWeight={600}>
                    <Typography
                        variant="subtitle2"
                        fontWeight={200}
                    ></Typography>
                </Typography>
            </Stack>
            <Stack spacing={2}>
                <FormControl fullWidth size="small" disabled={!isEditable}>
                    <InputLabel id="select-label">Type</InputLabel>
                    <Select
                        labelId="select-label"
                        id="select"
                        value={roi?.interpretedType}
                        label="Select"
                        size="small"
                        onChange={(e) =>
                            onInterpretedTypeChange(
                                e.target.value as RoiInterpretedType
                            )
                        }
                    >
                        {allowedTypes}
                    </Select>
                </FormControl>
            </Stack>
        </Box>
    );
}
